import i18next from 'i18next';
import type {PrimaryConfigOptions} from '@/email-maker/grapesjs-email-editor-plugin/src/index';

/**
 * Used to overwrite GrapesJS's existing i18n strings with ours. GrapesJS's locale will always be set to EN.
 * Don't want 2 different set of i18n implementations going our way.
 */
export default (opt: PrimaryConfigOptions): void => {
  const {editor} = opt;
  const i18n = editor.I18n;

  i18n.addMessages({
    en: {
      styleManager: {
        fileButton: i18next.t('pmwjs_upload'),
      },
    },
  });
};
